<template lang="pug">
div
    nav(class="or-navbar bg-dark relative")
        div(
            class="flex justify-between overflow-hidden lg:container"
            style="height: 52px;"
        )
            div(
                v-if="!$device.isSmall"
                class="flex flex-wrap flex-1 space-x-4"
                data-testid="navigationBar"
            )
                template(v-for="(navBarItem, index) in $navigationData.desktop.items")
                    div(v-if="navBarItem.type ==='spacer'" class="flex-grow")
                    NavBarItem(
                        v-else-if="navBarItem.type !=='sameDayButton'"
                        :data="navBarItem"
                        :isActive="activeMenu === index"
                        @showMenu="showMenu(index)"
                        @hideMenu="closeMenu"
                    )
                    SameDayButton(v-else-if="$config.runtime.theme.sameDayShipping.enabled && navBarItem.type==='sameDayButton'")

            FitmentButton(class="flex-1 lg:flex-none")
</template>

<script>
import NavBarItem from './_components/navbarItem'
import FitmentButton from './_components/fitmentButton'
const SameDayButton = () =>
    import(/* webpackChunkName: "navbar-sameDayButton" */ './_components/menus/sameDayButton')

export default {
    name: 'Navbar',
    components: {
        NavBarItem,
        FitmentButton,
        SameDayButton,
    },
    data() {
        return {
            activeMenu: null,
        }
    },
    mounted() {
        this.$uiEvents.$on('closeMenu', () => {
            this.closeMenu()
        })
    },
    beforeDestroy() {
        this.$uiEvents.$off('closeMenu')
    },
    methods: {
        closeMenu() {
            clearTimeout(this.navHoverTimer)

            this.navHoverTimer = setTimeout(() => {
                this.activeMenu = null
            }, 175)
        },
        showMenu(menuIndex) {
            clearTimeout(this.navHoverTimer)

            this.navHoverTimer = setTimeout(() => {
                this.activeMenu = menuIndex
            }, 175)
        },
    },
}
</script>
